import React, { useState } from "react";
import "../styles/courses.css";
import "../styles/master.css";
import coursesData from "../data/coursesData.json";

const Courses = () => {
  const [activeCategory, setActiveCategory] = useState(
    Object.keys(coursesData.categories)[0]
  );

  const keyHighlights = coursesData.keyHighlights;
  const courseWriteUp = coursesData.courseWriteUp;
  const courseWriteUp1 = coursesData.courseWriteUp1;

  return (
    <section id="courses" className="section">
      <h2 className="title">{coursesData.title}</h2>
      <p className="main-content">{courseWriteUp}</p>

      {/* Key Highlights Section */}
      <div className="key-highlights">
        <h3 className="sub-title-left">Key Highlights</h3>
        <ul className="custom-image-list">
          {keyHighlights.map((highlight, index) => (
            <li key={index}>{highlight}</li>
          ))}
        </ul>
      </div>

      <p className="main-content">{courseWriteUp1}</p>

      {/* Tabs Section */}
      <div className="tabs">
        {Object.keys(coursesData.categories).map((category) => (
          <div className="courses-container" key={category}>
            <button
              className={`tab ${category === activeCategory ? "active" : ""}`}
              onClick={() => setActiveCategory(category)}
            >
              {category}
            </button>
          </div>
        ))}
      </div>

      {/* Category Description */}
      <div className="category-description">
        <p>
          <strong>
            {coursesData.categories[activeCategory].description.bold}
          </strong>
          {coursesData.categories[activeCategory].description.text}
        </p>
      </div>
    </section>
  );
};

export default Courses;
